export default __webpack_public_path__ + "static/media/backgroundv1.329a8f7d.png";